import { InvoiceIntegrationStatusEnum } from 'anchor-scout/types';
import { IntegrationFailureModel } from "./IntegrationFailureModel";
export let InvoiceIntegrationStatusDTO = /*#__PURE__*/function (InvoiceIntegrationStatusDTO) {
  InvoiceIntegrationStatusDTO["PendingSync"] = "pendingSync";
  InvoiceIntegrationStatusDTO["Synced"] = "synced";
  InvoiceIntegrationStatusDTO["SyncFailed"] = "syncFailed";
  InvoiceIntegrationStatusDTO["PaymentFailed"] = "paymentFailed";
  InvoiceIntegrationStatusDTO["Voided"] = "voided";
  InvoiceIntegrationStatusDTO["Paid"] = "paid";
  InvoiceIntegrationStatusDTO["Refunded"] = "refunded";
  InvoiceIntegrationStatusDTO["RefundFailed"] = "refundFailed";
  return InvoiceIntegrationStatusDTO;
}({});
export let Status = /*#__PURE__*/function (Status) {
  Status["PendingSync"] = "pendingSync";
  Status["InvoiceSyncFailed"] = "invoiceSyncFailed";
  Status["PaymentSyncFailed"] = "paymentSyncFailed";
  Status["RefundSyncFailed"] = "refundSyncFailed";
  Status["InvoiceRecorded"] = "invoiceRecorded";
  Status["VoidedRecorded"] = "voidedRecorded";
  Status["RefundRecorded"] = "refundRecorded";
  Status["PaymentRecorded"] = "paymentRecorded";
  return Status;
}({});
export class InvoiceIntegrationModel {
  static fromDTO(dto, isZeroAmount) {
    switch (dto.status) {
      case InvoiceIntegrationStatusDTO.Synced:
        return new InvoiceIntegrationModel({
          status: Status.InvoiceRecorded,
          date: dto.synced.date
        });
      case InvoiceIntegrationStatusDTO.SyncFailed:
        return new InvoiceIntegrationModel({
          status: Status.InvoiceSyncFailed,
          failure: new IntegrationFailureModel(dto.syncFailed)
        });
      case InvoiceIntegrationStatusDTO.PaymentFailed:
        return new InvoiceIntegrationModel({
          status: Status.PaymentSyncFailed,
          failure: new IntegrationFailureModel(dto.paymentFailed)
        });
      case InvoiceIntegrationStatusDTO.PendingSync:
        {
          const {
            customerLinked,
            itemsLinked
          } = dto.pendingSync;
          return new InvoiceIntegrationModel({
            status: Status.PendingSync,
            customerLinked,
            itemsLinked
          });
        }
      case InvoiceIntegrationStatusDTO.Voided:
        return new InvoiceIntegrationModel({
          status: Status.VoidedRecorded,
          date: dto.voided.date
        });
      case InvoiceIntegrationStatusDTO.Paid:
        return new InvoiceIntegrationModel({
          status: isZeroAmount ? Status.InvoiceRecorded : Status.PaymentRecorded,
          date: dto.paid.date
        });
      case InvoiceIntegrationStatusDTO.Refunded:
        return new InvoiceIntegrationModel({
          status: Status.RefundRecorded,
          date: dto.refunded.date
        });
      case InvoiceIntegrationStatusDTO.RefundFailed:
        return new InvoiceIntegrationModel({
          status: Status.RefundSyncFailed,
          failure: new IntegrationFailureModel(dto.refundFailed)
        });
    }
  }
  static fromScoutDTO(dto) {
    switch (dto.status) {
      case InvoiceIntegrationStatusEnum.InvoiceRecorded:
        return new InvoiceIntegrationModel({
          status: Status.InvoiceRecorded,
          date: dto.date
        });
      case InvoiceIntegrationStatusEnum.InvoiceSyncFailed:
        return new InvoiceIntegrationModel({
          status: Status.InvoiceSyncFailed,
          failure: IntegrationFailureModel.fromScoutDTO(dto.date, dto.customFailure)
        });
      case InvoiceIntegrationStatusEnum.PaymentSyncFailed:
        return new InvoiceIntegrationModel({
          status: Status.PaymentSyncFailed,
          failure: IntegrationFailureModel.fromScoutDTO(dto.date, dto.customFailure)
        });
      case InvoiceIntegrationStatusEnum.PendingSync:
        return new InvoiceIntegrationModel({
          status: Status.PendingSync,
          customerLinked: false,
          itemsLinked: false
        });
      case InvoiceIntegrationStatusEnum.VoidedRecorded:
        return new InvoiceIntegrationModel({
          status: Status.VoidedRecorded,
          date: dto.date
        });
      case InvoiceIntegrationStatusEnum.PaymentRecorded:
        return new InvoiceIntegrationModel({
          status: Status.PaymentRecorded,
          date: dto.date
        });
      case InvoiceIntegrationStatusEnum.RefundRecorded:
        return new InvoiceIntegrationModel({
          status: Status.RefundRecorded,
          date: dto.date
        });
      case InvoiceIntegrationStatusEnum.RefundSyncFailed:
        return new InvoiceIntegrationModel({
          status: Status.RefundSyncFailed,
          failure: IntegrationFailureModel.fromScoutDTO(dto.date, dto.customFailure)
        });
    }
  }
  constructor(data) {
    this.data = data;
  }
  isSynced() {
    return [Status.InvoiceRecorded, Status.VoidedRecorded, Status.PaymentRecorded, Status.RefundRecorded].includes(this.data.status);
  }
  isInvoiceRecorded() {
    return this.data.status === Status.InvoiceRecorded;
  }
  isInvoiceSyncFailed() {
    return this.data.status === Status.InvoiceSyncFailed;
  }
  isSyncFailed() {
    return [Status.InvoiceSyncFailed, Status.PaymentSyncFailed, Status.RefundSyncFailed].includes(this.data.status);
  }
  isPendingSync() {
    return this.data.status === Status.PendingSync;
  }
  isPendingCustomerLinked() {
    return this.data.status === Status.PendingSync && !this.data.customerLinked;
  }
  isPendingItemsLinked() {
    return this.data.status === Status.PendingSync && !this.data.itemsLinked;
  }
  isPaymentSyncFailed() {
    return this.data.status === Status.PaymentSyncFailed;
  }
  isPaymentRecorded() {
    return this.data.status === Status.PaymentRecorded;
  }
  accept(visitor) {
    switch (this.data.status) {
      case Status.InvoiceRecorded:
        return visitor.whenInvoiceRecorded(this.data);
      case Status.VoidedRecorded:
        return visitor.whenVoidedRecorded(this.data);
      case Status.InvoiceSyncFailed:
        return visitor.whenInvoiceSyncFailed(this.data);
      case Status.PaymentSyncFailed:
        return visitor.whenPaymentSyncFailed(this.data);
      case Status.PendingSync:
        return visitor.whenPendingSync(this.data);
      case Status.PaymentRecorded:
        return visitor.whenPaymentRecorded(this.data);
      case Status.RefundRecorded:
        return visitor.whenRefundRecorded(this.data);
      case Status.RefundSyncFailed:
        return visitor.whenRefundSyncFailed(this.data);
    }
  }
}